<template>
  <aside class="sidebar">
    <div class="sidebar-header">
      <!-- App Logo & Title -->
      <div class="app-brand" @click="$router.push('/')" style="cursor: pointer">
        <div class="logo-row">
            <svg
                 version="1.1"
                 viewBox="0 0 472.44095 472.44095"
                 class="logo-icon-small"
                 xmlns="http://www.w3.org/2000/svg">
                <g transform="matrix(0.91925778,0,0,0.98630095,-242.65233,-175.86812)">
                  <path style="fill:none;stroke-width:1.5" d="m 325.03763,655.75103 c -3.7866,-0.73918 -11.70406,-3.74511 -17.59436,-6.67986 -17.35807,-8.64842 -31.01996,-24.27121 -39.1678,-44.78965 l -3.67064,-9.24367 -0.43888,-172.28918 c -0.48337,-189.74817 -0.89564,-180.52828 8.98566,-200.94512 9.85414,-20.36073 33.76611,-38.3505 55.80617,-41.98484 12.78098,-2.10753 378.62012,-1.96019 387.7457,0.15618 19.6507,4.55732 44.13327,23.89918 52.48576,41.46508 9.04951,19.03181 8.71202,11.33158 8.71202,198.78272 0,152.88497 -0.27056,172.87258 -2.44082,180.31282 -7.60406,26.06858 -26.77961,46.36908 -50.88591,53.87107 -9.45754,2.94325 -14.95671,3.02136 -201.18773,2.85715 -105.30541,-0.0928 -194.56254,-0.77355 -198.34917,-1.5127 z" />
                </g>
                <g transform="translate(-973.11873,-139.28225)">
                   <path style="fill:#00dc82" d="m 1190.8159,567.07242 c -9.4904,-2.96706 -25.7185,-12.37395 -79.5784,-46.12906 -24.0252,-15.05712 -46.2645,-30.11567 -49.4204,-33.46345 -5.4591,-5.79099 -5.7379,-6.75326 -5.7353,-19.7959 0,-18.28811 3.049,-24.16717 16.77,-32.37465 11.8394,-7.08194 91.8646,-49.30854 93.4463,-49.30854 0.5562,0 7.0237,3.96549 6.4985,9.27047 l -1.6071,16.23318 -7.9261,6.78063 c -12.898,11.03414 -17.6494,10.32254 -17.6494,25.83171 0,11.43815 1.0134,11.45981 5.9229,18.34407 6.4777,9.08318 15.372,15.87971 29.3788,21.45879 8.6827,3.45842 10.1495,4.17838 29.0658,4.14364 20.0831,-0.0369 21.4948,-1.67725 32.2807,-6.15473 38.5864,-16.01802 31.1541,-31.48264 14.5548,-63.8806 l -11.6,-8.55903 -1.3431,-14.56948 c -0.487,-5.28226 7.0376,-8.89865 7.7961,-8.89865 1.704,0 97.1515,51.29127 102.7675,55.22488 8.2197,5.75727 10.5909,11.77778 10.6033,26.92231 0.011,9.85389 -0.8081,15.3434 -2.6783,18.01349 -2.486,3.54915 -89.4086,59.78118 -112.4839,72.76816 -18.2292,10.25949 -41.868,13.51848 -59.0627,8.14276 z" />
                   <path style="fill:#00dc82" d="m 1199.8103,471.48573 c -0.3402,-0.0879 -2.7579,-0.57214 -5.3726,-1.07617 -8.6283,-1.66322 -15.6266,-4.33526 -21.3814,-8.16372 -3.7552,-2.49816 -5.5484,-4.09043 -7.8054,-6.93056 -3.3434,-4.20731 -4.6962,-7.76867 -4.5196,-11.89796 0.086,-2.00242 0.2893,-2.89171 0.9884,-4.31534 0.9847,-2.0056 3.0351,-5.27708 4.5356,-6.56594 l 2.2615,-1.94262 2.3445,1.72728 c 0.3246,0.40101 1.8038,2.25234 2.9803,4.56024 2.7535,5.4014 4.2015,6.31426 7.7568,9.02688 3.235,2.46831 5.4614,4.93388 10.0825,6.47599 4.9778,1.66113 7.8386,1.98502 16.3258,1.97879 13.7224,-0.0104 17.3612,-0.8265 24.3887,-5.07138 6.0155,-3.63347 8.5749,-6.82662 11.2508,-12.3934 1.8345,-3.81623 3.2362,-6.19668 3.7987,-6.19668 0.7576,0 5.4488,3.30384 6.5719,4.58584 0.5541,0.63258 1.4508,2.01403 1.9925,3.06987 0.8722,1.69947 0.9999,2.27879 1.1139,5.04991 0.1614,3.92694 -0.2943,5.59301 -2.4431,8.93232 -1.7159,2.66644 -5.7932,7.04034 -8.7847,9.42372 -2.22185,-3.68008 -7.824,0.29826 -15.7665,0.005 -20.5,-0.75792 z" />
                   <path style="fill:#064e3b" d="m 1209.8506,596.36274 c -3.575,-0.0512 -10.1261,-0.65657 -14.5579,-1.34532 -4.4319,-0.68876 -11.1819,-2.25959 -15,-3.49074 -3.8182,-1.23116 -9.8671,-3.70636 -13.4421,-5.50045 -3.575,-1.79409 -21.125,-12.15847 -39,-23.03194 -17.875,-10.87348 -40.1026,-24.32773 -49.3946,-29.89833 -9.7753,-5.86039 -19.5678,-12.59514 -23.2384,-15.98226 -4.3813,-4.04286 -7.353,-7.9018 -9.6055,-12.47354 -3.2615,-6.61967 -3.2615,-6.61967 -3.5907,-25.49146 -0.2577,-14.77363 0.027,-20.47206 1.3103,-26.24094 0.9017,-4.05304 2.7756,-9.50585 4.1641,-12.11735 z" />
                   <ellipse style="fill:#065f46" cx="1209.2928" cy="233.74191" rx="79.832024" ry="79.620979" />
                   <ellipse style="fill:#34d399" cx="1208.715" cy="233.5052" rx="62.693378" ry="61.556946" />
                   <path style="fill:#10b981" d="m 1155.8788,266.51806 c 2.2105,3.82631 2.2552,3.65802 3.6337,5.29612 2.8626,3.40168 6.0461,6.57356 9.5472,9.31378 4.0584,3.17648 8.4702,5.96705 13.1391,8.14931 4.7638,2.22661 9.7667,4.24934 14.9781,4.95196 9.4154,1.26945 19.1953,0.62408 28.4644,-1.4605 5.2521,-1.18116 10.2337,-3.52564 14.9298,-6.1573 4.1001,-2.29766 7.9651,-5.09266 11.3897,-8.3116 3.6692,-3.44876 6.8764,-7.42113 9.643,-11.6286 2.4553,-3.73408 4.5717,-7.74174 6.0837,-11.94718 1.8148,-5.04753 3.0231,-10.36363 3.5005,-15.70618 -0.4697,-5.25619 0.1826,-10.60697 -0.6495,-15.81809 -0.6105,-3.82303 -3.185,-12.04585 -3.1611,-11.17591 0.103,3.75252 -0.3959,8.32796 -0.5409,10.61515 z" />
                </g>
            </svg>
            <h1 class="sidebar-title">GAME PIVOT</h1>
        </div>
        <p class="sidebar-subtitle">{{ formattedGameCount }} Games</p>
      </div>

      <!-- Mobile-only explicit auth container placement handled via CSS but structure remains flat -->
      <div v-if="isMobile" class="auth-container-mobile">
          <!-- Auth moved here in mobile via CSS order or absolute positioning not ideal, 
               keeping simple: AuthButtons is flexible -->
      </div>
    </div> 

    <!-- Desktop-only auth placement: Moved to top below header -->
    <div class="auth-container desktop-auth">
      <AuthButtons />
    </div>

    <!-- Wrapper for horizontal scrolling on mobile -->
    <div class="mobile-controls-row">
      <div class="mode-selector">
        <button 
          :class="['mode-btn', { active: searchMode === 'general' }]"
          @click="$emit('set-mode', 'general')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mode-icon"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <span class="btn-text">General</span>
        </button>
        <button 
          :class="['mode-btn', { active: searchMode === 'steam' }]"
          @click="$emit('set-mode', 'steam')"
        >
          <!-- AUTHENTIC STEAM LOGO (USER PROVIDED PATHS) -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" class="mode-icon">
            <path d="M1.305 41.202C5.259 54.386 17.488 64 31.959 64c17.673 0 32-14.327 32-32s-14.327-32-32-32C15.001 0 1.124 13.193.028 29.874c2.074 3.477 2.879 5.628 1.275 11.328z" fill="#fff"/>
            <path d="M30.31 23.985l.003.158-7.83 11.375c-1.268-.058-2.54.165-3.748.662a8.14 8.14 0 0 0-1.498.8L.042 29.893s-.398 6.546 1.26 11.424l12.156 5.016c.6 2.728 2.48 5.12 5.242 6.27a8.88 8.88 0 0 0 11.603-4.782 8.89 8.89 0 0 0 .684-3.656L42.18 36.16l.275.005c6.705 0 12.155-5.466 12.155-12.18s-5.44-12.16-12.155-12.174c-6.702 0-12.155 5.46-12.155 12.174zm-1.88 23.05c-1.454 3.5-5.466 5.147-8.953 3.694a6.84 6.84 0 0 1-3.524-3.362l3.957 1.64a5.04 5.04 0 0 0 6.591-2.719 5.05 5.05 0 0 0-2.715-6.601l-4.1-1.695c1.578-.6 3.372-.62 5.05.077 1.7.703 3 2.027 3.696 3.72s.692 3.56-.01 5.246M42.466 32.1a8.12 8.12 0 0 1-8.098-8.113 8.12 8.12 0 0 1 8.098-8.111 8.12 8.12 0 0 1 8.1 8.111 8.12 8.12 0 0 1-8.1 8.113m-6.068-8.126a6.09 6.09 0 0 1 6.08-6.095c3.355 0 6.084 2.73 6.084 6.095a6.09 6.09 0 0 1-6.084 6.093 6.09 6.09 0 0 1-6.081-6.093z" fill="#09090b"/>
          </svg>
          <span class="btn-text">Steam</span>
        </button>
      </div>

      <div class="separator"></div>

      <div class="sidebar-header tight-spacing">
        <h3>Filters</h3>
      </div>

      <div class="filter-group">
        <label class="filter-checkbox">
          <input
            type="checkbox"
            v-model="includeAnime"
            :disabled="isSearching"
            @change="emitUpdate"
          />
          <span class="checkbox-label">Include Anime</span>
        </label>

        <label class="filter-checkbox">
          <input
            type="checkbox"
            v-model="includeAdult"
            :disabled="isSearching"
            @change="emitUpdate"
          />
          <span class="checkbox-label">Only 18+</span>
        </label>

        <label class="filter-checkbox">
          <input
            type="checkbox"
            v-model="includeVr"
            :disabled="isSearching"
            @change="emitUpdate"
          />
          <span class="checkbox-label">Include VR</span>
        </label>
      </div>

      <div class="separator"></div>

      <div class="filter-group">
         <label class="filter-checkbox">
          <input
            type="checkbox"
            v-model="randomize"
            :disabled="isSearching"
            @change="emitUpdate"
          />
          <span class="checkbox-label" title="Shuffle results">
              Shuffle Results
          </span>
        </label>
      </div>
    </div>

    <div class="sidebar-footer-links">
      <router-link to="/best" class="sidebar-footer-link">Best Of</router-link>
      <router-link to="/about" class="sidebar-footer-link">About</router-link>
      <router-link to="/privacy" class="sidebar-footer-link">Privacy</router-link>
      <a
        href="https://patreon.com/GamePivot?utm_medium=sidebar&utm_source=site&utm_campaign=site&utm_content=copyLink"
        target="_blank"
        rel="noopener noreferrer"
        class="sidebar-footer-link"
      >
        Patreon
      </a>
    </div>
    
  </aside>
</template>

<script>
import AuthButtons from './AuthButtons.vue';

export default {
  name: 'FilterSidebar',
  components: { AuthButtons },
  props: {
      isSearching: Boolean,
      searchMode: String
  },
  data() {
    return {
      includeAnime: JSON.parse(localStorage.getItem('pref_include_anime') || 'false'),
      includeAdult: JSON.parse(localStorage.getItem('pref_include_adult') || 'false'),
      includeVr: JSON.parse(localStorage.getItem('pref_include_vr') || 'false'),
      randomize: false
    };
  },
  computed: {
    formattedGameCount() {
        return (this.$store.state.totalGameCount || 50000).toLocaleString();
    }
  },
  methods: {
      emitUpdate() {
          // Save prefs
          localStorage.setItem('pref_include_anime', this.includeAnime);
          localStorage.setItem('pref_include_adult', this.includeAdult);
          localStorage.setItem('pref_include_vr', this.includeVr);

          this.$emit('update-filters', {
              includeAnime: this.includeAnime,
              includeAdult: this.includeAdult,
              includeVr: this.includeVr,
              random: this.randomize
          });
      }
  },
  mounted() {
      // Emit initial state
      this.emitUpdate();
  }
};
</script>

<style scoped>
.sidebar {
    width: 280px;
    background: #09090b;
    border-right: 1px solid #18181b;
    padding: 24px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 24px; /* Restored to 24px */
    z-index: 100;
    box-sizing: border-box; /* Fix width to include padding */
}

.sidebar-header h3 {
    font-size: 0.85rem;
    color: #52525b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 700;
}

.tight-spacing {
    margin-top: -16px;
    margin-bottom: 0px; /* Ensure no extra bottom margin */
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.filter-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
}


.auth-container {
    margin-bottom: 0; /* Let gap handle spacing */
}

@media (max-width: 1024px) {
    .desktop-auth {
        display: none;
    }
    
    .sidebar-header {
        position: relative;
    }

    .sidebar-footer-links {
        margin-top: 0;
        padding-top: 0;
        border-top: none;
        flex-direction: row;
        gap: 16px;
        flex-shrink: 0;
        align-items: center;
    }

    .sidebar-footer-link {
        font-size: 0.78rem;
        white-space: nowrap;
    }
    
}

.mode-selector {
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* Removed border and spacing to avoid double lines and gaps */
}

.mode-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #18181b;
    border: 1px solid #27272a;
    color: #a1a1aa;
    padding: 12px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 600;
    text-align: left;
}

.mode-btn:hover {
    background: #27272a;
    color: #e4e4e7;
    border-color: #3f3f46;
}

.mode-btn.active {
    background: rgba(0, 220, 130, 0.1);
    border-color: #00dc82;
    color: #00dc82;
}

.mode-icon {
    width: 18px;
    height: 18px;
}

.filter-checkbox:hover .checkbox-label {
  color: #fff;
}

.filter-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #00dc82;
  border-radius: 2px;
}

.checkbox-label {
    font-size: 0.9rem;
    color: #a1a1aa;
    font-weight: 500;
    transition: color 0.2s;
}

.separator {
    height: 1px;
    background: #18181b;
    width: 100%;
}


.logo-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.app-brand {
    padding-bottom: 24px; /* Restored padding */
    margin-bottom: 0; /* Let gap handle spacing */
    border-bottom: 1px solid #18181b;
}

.logo-icon-small {
    width: 32px;
    height: 32px;
    color: #00dc82;
    filter: drop-shadow(0 0 8px rgba(0, 220, 130, 0.3));
}

.sidebar-title {
    font-family: 'Space Grotesk', sans-serif;
    font-size: 1.4rem;
    font-weight: 800;
    margin: 0;
    line-height: 1;
    letter-spacing: -0.5px;
    color: #00dc82;
    text-shadow: 0 0 10px rgba(0, 220, 130, 0.3);
    text-transform: uppercase;
}

.sidebar-subtitle {
    font-size: 0.8rem;
    color: #71717a;
    margin: 0;
    margin-left: 2px;
}

/* Wrapper for desktop layout to maintain spacing */
.mobile-controls-row {
    display: flex;
    flex-direction: column;
    gap: 24px; /* Restored from 16px */
}


/* Mobile Responsive */
@media (max-width: 1024px) {
    .sidebar {
        width: 100%;
        height: auto;
        position: sticky;
        top: 0;
        bottom: auto;
        left: 0;
        z-index: 100;
        border-right: none;
        border-bottom: 1px solid #27272a;
        flex-direction: column;
        padding: 12px 16px;
        gap: 12px;
        background: rgba(9, 9, 11, 0.95);
        backdrop-filter: blur(10px);
    }
    
    .sidebar-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0;
    }

    .app-brand {
        margin: 0;
        padding: 0;
        border: none;
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .logo-row {
        margin-bottom: 0;
    }

    /* Hide subtitle on mobile to save space */
    .sidebar-subtitle {
        display: none;
    }

    /* Auth container in header on mobile */
    .auth-container {
        margin: 0;
    }

    /* Horizontal scroll container for controls */
    .mobile-controls-row {
        display: flex;
        width: 100%;
        gap: 12px;
        overflow-x: auto;
        align-items: center;
        padding-bottom: 4px; /* Space for scrollbar if visible */
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none; /* Hide scrollbar Firefox */
    }
    
    .mobile-controls-row::-webkit-scrollbar {
        display: none; /* Hide scrollbar Chrome/Safari */
    }

    .mode-selector {
        flex-direction: row;
        border: none;
        padding: 0;
        margin: 0;
        flex-shrink: 0;
    }

    .filter-group {
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 12px;
        flex-shrink: 0;
    }
    
    .separator {
        display: block;
        width: 1px;
        height: 24px;
        background: #27272a;
        flex-shrink: 0;
    }

    /* Hide the "Filters" header text */
    .sidebar-header h3 {
        display: none;
    }
}

.sidebar-footer-links {
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #18181b;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sidebar-footer-link {
    color: #71717a;
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    transition: color 0.2s ease;
}

.sidebar-footer-link:hover {
    color: #00dc82;
}
</style>
